/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './History.css';
import ReactEcharts from 'echarts-for-react'
import moment from 'moment'

class History extends React.Component {

    constructor(props) {
        super(props)
        this.state = {}
        this.getOption = this
            .getOption
            .bind(this)
    }
    // componentWillUpdate() {
    //     console.log(this.props)
    // }

    getOption = () => {
        // console.log(this.props)
        // var xAxisData = [];
        // var data1 = [];
        // var data2 = [];
        // var data3 = [];
        // var data4 = [];
        // var data5 = [];
        // for (var i = 0; i < 30; i++) {
        //     // xAxisData.push('类目' + i);
        //     data1.push((Math.sin(i / 5) * (i / 5 - 10) + i / 6) * 5);
        //     data2.push((Math.cos(i / 5) * (i / 5 - 10) + i / 6) * 5);
        //     data3.push((Math.cos(i / 6) * (i / 6 - 10) + i / 6) * 5);
        //     data4.push((Math.cos(i / 7) * (i / 7 - 10) + i / 6) * 5);
        //     var ss = data1[i] + data2[i] + data3[i] + data4[i]
        //     data5.push(ss)
        // }
        // console.log(this.props.json,this.props.json[0],this.props.json[1])
         let data1=[].concat(this.props.json[0])
         let data2=[].concat(this.props.json[1])
         let data3=[].concat(this.props.json[2])
         let data4=[].concat(this.props.json[3])
         let data5=[].concat(this.props.json[4])


        // for(var i=0;i<30;i++){ data5.push(data1[i]+data2[i]+data3[i]+data4[i]) }
        const timeArr = []

        const m=(this.props.time.substring(5,7))-1
        const d=Number(this.props.time.substring(8,10))+1
        let time= moment().set({'month':m,'date':d})
        for (var i = 0; i < 30; i++) {
            timeArr.unshift(time.subtract(1, 'days').format('MM-DD'))
            // timeArr.push(i)
        }
        
        // console.log(timeArr)
        // console.log(data5,data1,data2,data3,data4)

        const option = {
            title: {
                text: `历史曲线图 - ${this.props.items.name}`,
                subtext: '数据来源：数字品牌榜',
                // sublink:'',
                x: '20'
            },
            color: [
                '#c2e1c5', '#fac8a7', '#abd9f2', '#f1b1ad'
            ],
            legend: {
                data: [
                    '微信', '微博', '知乎', '今日头条', 'DB总值'
                ],
                align: 'left'
            },
            toolbox: {
                right: 20,
                show: true,
                feature: {
                    mark: {
                        show: true
                    },
                    //          dataView : {show: true, readOnly: false},
                    magicType: {
                        show: true,
                        type: ['pie', 'funnel']
                    },
                    restore: {
                        show: true
                    },
                    saveAsImage: {
                        show: true
                    }
                }
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            xAxis: {
                data: timeArr,
                type: 'category',
                silent: false,
                splitLine: {
                    show: false
                }
            },
            yAxis: [
                {
                    type: 'value',
                    boundaryGap: [0.2, 0.2]
                }

            ],
            series: [
                {
                    name: '微信',
                    type: 'bar',
                    stack: '总值',
                    data: data1,
                    animationDelay: function (idx) {
                        return idx * 10;
                    }
                }, {
                    name: '微博',
                    type: 'bar',
                    stack: '总值',
                    data: data2,
                    animationDelay: function (idx) {
                        return idx * 10 + 100;
                    }
                }, {
                    name: '知乎',
                    type: 'bar',
                    stack: '总值',
                    data: data3,
                    animationDelay: function (idx) {
                        return idx * 10 + 100;
                    }
                }, {
                    name: '今日头条',
                    type: 'bar',
                    stack: '总值',
                    data: data4,
                    animationDelay: function (idx) {
                        return idx * 10 + 100;
                    }
                }, {
                    name: 'DB总值',
                    type: 'line',
                    lineStyle: {
                        normal: {
                            type: 'dashed',
                            color: '#777'
                        }
                    },
                    // label:{   normal:{       show:true,       position:'top',       color:'#000'
                    //  } },
                    data: data5,
                    // yAxisIndex:1
                }
            ],
            animationEasing: 'elasticOut',
            animationDelayUpdate: function (idx) {
                return idx * 5;
            }
        };
        return option
    }

    render() {

        // console.log(timeArr)

        return (<ReactEcharts
            option={this.getOption()}
            style={{
            height: '550px',
            width:'100%',
            
            borderRadius: '4px'
        }}
            className={s.charts}
            notMerge={true}
            lazyUpdate={true}
            theme={"theme_name"}
            onChartReady={this.onChartReadyCallback}/>)

    }
}

export default withStyles(s)(History);



// WEBPACK FOOTER //
// src/components/History/History.js